export default __webpack_public_path__ + "static/media/PP_OG.7a4c86da.svg";